"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.USER_CREATED_COUNTER = exports.SNAPSHOT_TAKEN_COUNTER = exports.GAMES_FINISHED_COUNTER = exports.GAMES_STARTED_COUNTER = exports.GAMES_CREATED_COUNTER = void 0;
exports.GAMES_CREATED_COUNTER = "gamesCreated";
exports.GAMES_STARTED_COUNTER = "gamesStarted";
exports.GAMES_FINISHED_COUNTER = "gamesFinished";
exports.SNAPSHOT_TAKEN_COUNTER = "snapshotTaken";
exports.USER_CREATED_COUNTER = "userCreated";
//# sourceMappingURL=Stats.js.map